import React from 'react';

import { IconInput } from 'shared/components/molecules/IconInput/IconInput';
import { Button } from 'shared/components/atoms/Button/Button';
import { Select } from 'shared/components/molecules/Select/Select';

import { Container } from './_secondRegisterGroup';

import filled_man from 'assets/icons/filled_man.svg';
import gray_filled_man from 'assets/icons/gray_filled_man.svg';
import { cnpjFormat } from 'utils/format';

export interface OptionValues {
  label: string;
  value: string;
}

interface RegisterProps {
  categoryOptions: OptionValues[];
  category: OptionValues;
  setCategory: Function;
  cnpj: string;
  setCnpj: Function;
  setCurrentStep: Function;
}

export const SecondRegisterGroup: React.FC<RegisterProps> = ({
  category,
  setCategory,
  categoryOptions,
  cnpj,
  setCnpj,
  setCurrentStep,
}) => {
  const options = [
    {
      label: 'Montador de móveis',
      value: 'montador de móveis',
    },
    {
      label: 'Técnico de informática',
      value: 'tecnico de informatica',
    },
    {
      label: 'Instalador de eletrodomésticos',
      value: 'instalador de eletrodomésticos',
    },
  ];

  const handleError = (error: string) => {};

  const disableCondition = () => {
    if (category.value.length === 0) {
      return true;
    }

    // CNPJ opcional, mas se for preenchido deve ter o tamanho correto
    if (cnpj.length && cnpj.length < 18) {
      return true;
    }

    return false;
  };

  return (
    <Container className="group-wrapper">
      <Select
        selectedItem={category}
        setSelectedItem={setCategory}
        options={categoryOptions}
      />

      <IconInput
        icon={gray_filled_man}
        activeIcon={filled_man}
        placeholder={'CNPJ (Opcional)'}
        inputValue={cnpjFormat(cnpj)}
        setInputValue={setCnpj}
      />

      <Button onClick={() => setCurrentStep(1.1)} disabled={disableCondition()}>
        Próximo
      </Button>
      <Button backgroundColor='#C42D2D' onClick={() => setCurrentStep(0)}>
        Voltar
      </Button>
    </Container>
  );
};
